import styled from 'styled-components';
// import {} from 'styles/colorProvider'

export const Container = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: column;
`;
